module.exports = __webpack_public_path__ + "img/interface_flower.22bb5647.png";